;(() => {
  if (customElements.get('products-feed')) {
    return
  }

  class ProductsFeed extends HTMLElement {
    constructor() {
      super()

      this.sliderInstance = null
      this.sliderConfig = {
        arrows: false,
        pagination: false,
        waitForTransition: false,
        wheel: true,
        releaseWheel: true,
        fixedWidth: window.innerWidth > 990 ? 'width: 27.92%' : 'width: 48.3%;',
      }
      this.initSliderHandler = this.initSlider.bind(this)
    }

    connectedCallback() {
      this.initSliderHandler()
    }

    initSlider() {
      const slider = this.querySelector('.splide')

      if (!slider) {
        return
      }

      this.sliderInstance = new Splide(slider, this.sliderConfig).mount()

      return this.sliderInstance
    }
  }

  customElements.define('products-feed', ProductsFeed)
})()
